import { render, staticRenderFns } from "./activity-tab.vue?vue&type=template&id=08093bdf"
import script from "./activity-tab.vue?vue&type=script&lang=js"
export * from "./activity-tab.vue?vue&type=script&lang=js"
import style0 from "./activity-tab.vue?vue&type=style&index=0&id=08093bdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports